import { useEffect, useState } from 'react';

export function useMatchMedia(media) {
	const [matches, setMatches] = useState<boolean | undefined>(undefined);

	useEffect(() => {
		const mediaQueryList = window.matchMedia(media);
		const handleMatchChange = (event) => setMatches(event.matches);

		setMatches(mediaQueryList.matches);
		mediaQueryList.addListener(handleMatchChange);

		return () => {
			mediaQueryList.removeListener(handleMatchChange);
		};
	}, [media]);

	return matches;
}
